/**
 * Utility functions for formatting data
 */

/**
 * Converts an enum value like "LIKE_NEW" to a more readable format like "Like New"
 * @param value The enum value to convert
 * @returns The formatted string
 */
export const getEnumLabel = (value: string): string => {
  return value
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
    .replace(/-/g, ' ');
};
